const options = {
  threshold: 0,
};

type subscriber = () => void;

class Observer {
  intersectionObserver: IntersectionObserver;
  subscribers: {
    [key: string]: { isVisible: subscriber; isHidden: subscriber }[];
  };

  constructor() {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => this.callback(entries),
      options,
    );
    this.subscribers = {};
  }

  callback(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      const $element = entry.target as HTMLElement;
      if ($element.dataset.id) {
        for (const subscriberCallbacks of this.subscribers[
          $element.dataset.id
        ]) {
          if (entry.isIntersecting) {
            subscriberCallbacks.isVisible();
          } else {
            subscriberCallbacks.isHidden();
          }
        }
      }
    }
  }

  subscribe(
    $element: HTMLElement,
    id: string,
    callbacks: { isVisible: subscriber; isHidden: subscriber },
  ) {
    if ($element !== null) {
      if (
        typeof this.subscribers[id] !== 'undefined' &&
        this.subscribers[id].length
      ) {
        this.subscribers[id] = [...this.subscribers[id], callbacks];
      } else {
        this.subscribers[id] = [callbacks];
      }
      this.intersectionObserver.observe($element);
      return () => {
        this.unsubscribe($element);
      };
    }
    // We return an empty function if $element is null to prevent JS breaking
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  }

  unsubscribe($element: HTMLElement) {
    this.intersectionObserver.unobserve($element);
    delete this.subscribers[$element.id];
  }
}

const ObserverInstance = new Observer();

export default ObserverInstance;
